import { ReactLenis } from "lenis/react";
import { usePrefersReducedMotion } from "@/hooks/useReducedMotion";

// Global smooth momentum scrolling via Lenis.
// Disabled entirely when the user prefers reduced motion.
export const SmoothScroll = ({ children }) => {
  const reduced = usePrefersReducedMotion();

  if (reduced) return <>{children}</>;

  return (
    <ReactLenis
      root
      options={{
        lerp: 0.09,
        duration: 1.2,
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 1.5,
      }}
    >
      {children}
    </ReactLenis>
  );
};

export default SmoothScroll;
